import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface DemoCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  url: string;
}
export function DemoCard({
  title,
  description,
  icon,
  url
}: DemoCardProps) {
  return <motion.a href={url} target="_blank" rel="noopener noreferrer" className="group relative flex flex-col p-6 rounded-2xl bg-dinesafe-card border border-dinesafe-border transition-all duration-300 hover:bg-dinesafe-cardHover hover:border-dinesafe-accent/50 hover:shadow-[0_0_30px_rgba(92,224,210,0.15)] overflow-hidden" whileHover={{
    y: -4
  }} variants={{
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }
  }} data-id="element-16">
      <div className="mb-4 inline-flex items-center justify-center w-12 h-12 rounded-xl bg-dinesafe-accent/10 text-dinesafe-accent" data-id="element-17">
        {icon}
      </div>

      <h3 className="text-[1.35rem] font-bold text-dinesafe-text mb-2 group-hover:text-dinesafe-accent transition-colors" data-id="element-18">
        {title}
      </h3>

      <p className="text-[0.95rem] text-dinesafe-muted mb-6 flex-grow leading-relaxed" data-id="element-19">
        {description}
      </p>

      <div className="flex items-center text-sm font-medium text-dinesafe-accent mt-auto" data-id="element-20">
        Launch Demo
        <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" data-id="element-21" />
      </div>

      {/* Subtle top gradient line on hover */}
      <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-dinesafe-accent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-22" />
    </motion.a>;
}